// 防重复点击、v-debounce指令的值必须为数值（毫秒），默认值为1000毫秒
export default {
  bind(el, binding) {
    if (binding.value && typeof binding.value !== "number") {
      console.warn("It must be a number");
    }

    const delay = binding.value || 1000;

    el.clickHandler = e => {
      if (el._debounce_lock) return;

      el._debounce_lock = true;
      // 禁止点击
      el.style.pointerEvents = "none";
      // 也可以添加样式效果，例如灰度
      // el.classList.add("debounce-disabled");

      setTimeout(() => {
        el._debounce_lock = false;
        el.style.pointerEvents = "";
        el.classList.remove("debounce-disabled");
      }, delay);
    };

    el.addEventListener("click", el.clickHandler);
  },
  unbind(el) {
    if (el.clickHandler) {
      el.removeEventListener("click", el.clickHandler);
    }
  },
};
